import * as ambassadorWixSearchV1Sitedocument from './search-v1-sitedocument-site-search.http.js';
import * as ambassadorWixSearchV1SitedocumentTypes from './search-v1-sitedocument-site-search.types.js';
import * as ambassadorWixSearchV1SitedocumentUniversalTypes from './search-v1-sitedocument-site-search.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function search(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixSearchV1SitedocumentUniversalTypes.SearchRequest,
  ambassadorWixSearchV1SitedocumentTypes.SearchRequest,
  ambassadorWixSearchV1SitedocumentUniversalTypes.SearchResponse,
  ambassadorWixSearchV1SitedocumentTypes.SearchResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixSearchV1Sitedocument.search(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/api/v1/search',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function federatedSearch(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixSearchV1SitedocumentUniversalTypes.FederatedSearchRequest,
  ambassadorWixSearchV1SitedocumentTypes.FederatedSearchRequest,
  ambassadorWixSearchV1SitedocumentUniversalTypes.FederatedSearchResponse,
  ambassadorWixSearchV1SitedocumentTypes.FederatedSearchResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixSearchV1Sitedocument.federatedSearch(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/api/v1/search/federated',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function suggest(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixSearchV1SitedocumentUniversalTypes.SuggestRequest,
  ambassadorWixSearchV1SitedocumentTypes.SuggestRequest,
  ambassadorWixSearchV1SitedocumentUniversalTypes.SuggestResponse,
  ambassadorWixSearchV1SitedocumentTypes.SuggestResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixSearchV1Sitedocument.suggest(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/api/v1/suggest',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function federatedSuggest(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixSearchV1SitedocumentUniversalTypes.FederatedSuggestRequest,
  ambassadorWixSearchV1SitedocumentTypes.FederatedSuggestRequest,
  ambassadorWixSearchV1SitedocumentUniversalTypes.FederatedSuggestResponse,
  ambassadorWixSearchV1SitedocumentTypes.FederatedSuggestResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixSearchV1Sitedocument.federatedSuggest(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/api/v1/suggest/federated',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function related(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixSearchV1SitedocumentUniversalTypes.RelatedRequest,
  ambassadorWixSearchV1SitedocumentTypes.RelatedRequest,
  ambassadorWixSearchV1SitedocumentUniversalTypes.RelatedResponse,
  ambassadorWixSearchV1SitedocumentTypes.RelatedResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixSearchV1Sitedocument.related(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/api/v1/related',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function autocomplete(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixSearchV1SitedocumentUniversalTypes.AutocompleteRequest,
  ambassadorWixSearchV1SitedocumentTypes.AutocompleteRequest,
  ambassadorWixSearchV1SitedocumentUniversalTypes.AutocompleteResponse,
  ambassadorWixSearchV1SitedocumentTypes.AutocompleteResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixSearchV1Sitedocument.autocomplete(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/api/v1/autocomplete',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function federatedAutocomplete(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixSearchV1SitedocumentUniversalTypes.FederatedAutocompleteRequest,
  ambassadorWixSearchV1SitedocumentTypes.FederatedAutocompleteRequest,
  ambassadorWixSearchV1SitedocumentUniversalTypes.FederatedAutocompleteResponse,
  ambassadorWixSearchV1SitedocumentTypes.FederatedAutocompleteResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixSearchV1Sitedocument.federatedAutocomplete(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/api/v1/autocomplete/federated',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function trending(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixSearchV1SitedocumentUniversalTypes.TrendingRequest,
  ambassadorWixSearchV1SitedocumentTypes.TrendingRequest,
  ambassadorWixSearchV1SitedocumentUniversalTypes.TrendingResponse,
  ambassadorWixSearchV1SitedocumentTypes.TrendingResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixSearchV1Sitedocument.trending(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/api/v1/trending',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  SiteDocument as SiteDocumentOriginal,
  UpdateInternalDocumentsEvent as UpdateInternalDocumentsEventOriginal,
  UpdateInternalDocumentsEventOperationOneOf as UpdateInternalDocumentsEventOperationOneOfOriginal,
  InternalDocument as InternalDocumentOriginal,
  InternalDocumentUpdateOperation as InternalDocumentUpdateOperationOriginal,
  DeleteByIdsOperation as DeleteByIdsOperationOriginal,
  DeleteByFilterOperation as DeleteByFilterOperationOriginal,
  InternalDocumentUpdateByFilterOperation as InternalDocumentUpdateByFilterOperationOriginal,
  InternalUpdateExistingOperation as InternalUpdateExistingOperationOriginal,
  VersionedDocumentUpdateOperation as VersionedDocumentUpdateOperationOriginal,
  VersioningMode as VersioningModeOriginal,
  VersioningModeWithLiterals as VersioningModeWithLiteralsOriginal,
  VersionedDeleteByIdsOperation as VersionedDeleteByIdsOperationOriginal,
  VersionedDocumentId as VersionedDocumentIdOriginal,
  UpdateDocumentsEvent as UpdateDocumentsEventOriginal,
  UpdateDocumentsEventOperationOneOf as UpdateDocumentsEventOperationOneOfOriginal,
  DocumentUpdateOperation as DocumentUpdateOperationOriginal,
  IndexDocument as IndexDocumentOriginal,
  DocumentPayload as DocumentPayloadOriginal,
  DocumentImage as DocumentImageOriginal,
  Enum as EnumOriginal,
  EnumWithLiterals as EnumWithLiteralsOriginal,
  V1DeleteByIdsOperation as V1DeleteByIdsOperationOriginal,
  V1DeleteByFilterOperation as V1DeleteByFilterOperationOriginal,
  UpdateByFilterOperation as UpdateByFilterOperationOriginal,
  UpdateExistingOperation as UpdateExistingOperationOriginal,
  Empty as EmptyOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  SearchRequest as SearchRequestOriginal,
  OrderingClauses as OrderingClausesOriginal,
  OrderingClause as OrderingClauseOriginal,
  Direction as DirectionOriginal,
  DirectionWithLiterals as DirectionWithLiteralsOriginal,
  SearchPaging as SearchPagingOriginal,
  FacetClauses as FacetClausesOriginal,
  FacetClause as FacetClauseOriginal,
  FacetClauseClauseOneOf as FacetClauseClauseOneOfOriginal,
  Aggregation as AggregationOriginal,
  AggregationWithLiterals as AggregationWithLiteralsOriginal,
  HierarchicalFacet as HierarchicalFacetOriginal,
  HierarchicalFacetClauseOneOf as HierarchicalFacetClauseOneOfOriginal,
  TermFacet as TermFacetOriginal,
  AggregationFacet as AggregationFacetOriginal,
  SearchProperty as SearchPropertyOriginal,
  SearchResponse as SearchResponseOriginal,
  NextPageResponse as NextPageResponseOriginal,
  FacetsResponse as FacetsResponseOriginal,
  FacetsResponseResponseOneOf as FacetsResponseResponseOneOfOriginal,
  FacetCountResponse as FacetCountResponseOriginal,
  Value as ValueOriginal,
  TermAggregationResponse as TermAggregationResponseOriginal,
  MinAggregationResponse as MinAggregationResponseOriginal,
  MaxAggregationResponse as MaxAggregationResponseOriginal,
  MinMaxAggregationResponse as MinMaxAggregationResponseOriginal,
  HierarchicalAggregationResponse as HierarchicalAggregationResponseOriginal,
  SumAggregationResponse as SumAggregationResponseOriginal,
  FederatedSearchRequest as FederatedSearchRequestOriginal,
  FederatedSearchResponse as FederatedSearchResponseOriginal,
  FederatedSearchDocuments as FederatedSearchDocumentsOriginal,
  SuggestRequest as SuggestRequestOriginal,
  SuggestResponse as SuggestResponseOriginal,
  FederatedSuggestRequest as FederatedSuggestRequestOriginal,
  FederatedSuggestResponse as FederatedSuggestResponseOriginal,
  FederatedSuggestDocuments as FederatedSuggestDocumentsOriginal,
  RelatedRequest as RelatedRequestOriginal,
  RelatedResponse as RelatedResponseOriginal,
  AutocompleteRequest as AutocompleteRequestOriginal,
  AutocompleteResponse as AutocompleteResponseOriginal,
  AutocompleteResponseValue as AutocompleteResponseValueOriginal,
  FederatedAutocompleteRequest as FederatedAutocompleteRequestOriginal,
  FederatedAutocompleteResponse as FederatedAutocompleteResponseOriginal,
  FederatedAutocompleteResults as FederatedAutocompleteResultsOriginal,
  TrendingRequest as TrendingRequestOriginal,
  TrendingResponse as TrendingResponseOriginal,
  TrendingItems as TrendingItemsOriginal,
} from './search-v1-sitedocument-site-search.types.js';
